import axios from 'axios'
import qs from 'qs'
// import global from '../public/global.js'
//超時設置
axios.defaults.timeout = 60 * 1000 * 3;

axios.defaults.transformRequest = function (data,e) {		
	if(e['Content-Type'] && (e['Content-Type'].indexOf('multipart/form-data;') >= 0)){		
		return data;
	}	
	if(e['Content-Type'] && (e['Content-Type'].indexOf('application/json') >= 0)){		
		return JSON.stringify(data);
	}
	return qs.stringify(data);
};
axios.interceptors.request.use(config => {
	// 强行中断请求要用到的，记录请求信息
	// config['cancelToken'] = new axios.CancelToken(function (cancel) {		
	// 	global.requests.push(cancel) //存储cancle
	// })
	return config;
});
//數據包裝
axios.interceptors.response.use(function (res) {
	if(res.status == 200){
		//原數據返回
		return res.data;
	}
}, function (error) {
	return Promise.reject(error)
});
axios.uploadFile = function(url,data,conf){	
	let config = {
			headers: {"Content-Type": "multipart/form-data;"},
			withCredentials: true,
			timeout: 60 * 1000 * 3 // 3分钟
		};
		for(let k in conf){
			config[k] = conf[k];
		}
	return axios.post(url,data,config)
}
//添加jsonp方法
axios.jsonp = (url,query) => {
	if(!url){
			console.error('Please input url')
			return;
	}
	return new Promise((resolve) => {
			window.jsonCallBack =(result) => {
					resolve(result)
			}
			var JSONP=document.createElement("script");
			JSONP.type="text/javascript";
			let qStr = ""
			for(let k in query){
				qStr += "&"+ k + "=" + query[k];
			}
			JSONP.src=`${url}?callback=jsonCallBack${qStr}`;
			document.getElementsByTagName("head")[0].appendChild(JSONP);
			setTimeout(() => {
					document.getElementsByTagName("head")[0].removeChild(JSONP)
			},500)
	})
}
export default axios;